import { mergeArrays } from "./modules/utils";

const ACLGlobalControlParameterTypePolicy = {
  ACLGlobalControlParameter: {
    fields: {
      roleValueData: {
        /**
         * This field returns an array of ACLGlobalRole objects. Since, these objects are not normalized, we can't merge cached object and incoming object from network response/cache write by their ids.
         * So, we are always merging the arrays by index.
         */
        merge: mergeArrays,
      },
      mappedTemplates: {
        /**
         * Same as above except, this field returns an array of ACLGlobalTemplate objects.
         */
        merge: mergeArrays,
      },
    },
  },
};

export default ACLGlobalControlParameterTypePolicy;
